module.exports = __webpack_public_path__ + "img/collect.5088dcea.svg";